/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  RiskScoreRevealResponse,
  RiskScoreRevealType
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * @summary Get Risk Score Reveal By Type
 */
export const getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet = (
    revealType: RiskScoreRevealType,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<RiskScoreRevealResponse>(
      {url: `/v1/risk-score-reveal/${revealType}`, method: 'GET', signal
    },
      );
    }
  



export const getGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGetQueryKey = (revealType?: RiskScoreRevealType,) => {
    return [
    `/v1/risk-score-reveal/${revealType}`
    ] as const;
    }

    
export const getGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGetQueryOptions = <TData = Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError = HTTPValidationError>(revealType: RiskScoreRevealType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGetQueryKey(revealType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>> = ({ signal }) => getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet(revealType, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(revealType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>>
export type GetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGetQueryError = HTTPValidationError


export function useGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError = HTTPValidationError>(
 revealType: RiskScoreRevealType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError = HTTPValidationError>(
 revealType: RiskScoreRevealType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError = HTTPValidationError>(
 revealType: RiskScoreRevealType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Risk Score Reveal By Type
 */

export function useGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet<TData = Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError = HTTPValidationError>(
 revealType: RiskScoreRevealType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRiskScoreRevealByTypeV1RiskScoreRevealRevealTypeGetQueryOptions(revealType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




